import { Trans, useTranslation } from "react-i18next";
import { usePictureSets } from "../../hooks/usePictureSets";
import { useHistory } from "react-router";
import React, { useState } from "react";
import { callAPI } from "../../../lib/common";
import { reportSubjects } from "@/react/Webshop/CopyrightAcknowledgement/copyrightAcknowledgement";
import Popup, {
  PopupContent,
  PopupHeading,
  PopupTextContent,
} from "../../../components/Common/Popup";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import LoadingButton from "../../../components/LoadingButton";
import makeStyles from "@mui/styles/makeStyles";
import useRoutes from "../../hooks/useRoutes";
import WarningLastSubjectNotSelectedDialog from "../../Components/WarningLastSubjectNotSelectedDialog";
import { usePriceList } from "@/react/Webshop/providers/PriceListProvider";

const useStyles = makeStyles((theme) => ({
  codeTextField: {
    marginRight: theme.spacing(2),
    flexBasis: 1,
    flexGrow: 1,
  },
  button: {
    flexBasis: 1,
    flexGrow: 1,
  },
}));

const AddSubjectDialog = ({ onClose }) => {
  const { t } = useTranslation();
  const { update } = usePictureSets();
  const { updatePriceList } = usePriceList();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [warning, setWarning] = useState(null);
  const [code, setCode] = useState("");
  const classes = useStyles();
  const routes = useRoutes();

  const addPictureSet = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(false);
    setWarning(null);
    callAPI("/ajax/prophoto/add_picture_set_by_code.php?code=" + code)
      .then((result) => {
        // Previews of the new subject wait for the copyright acknowledgement.
        reportSubjects(result.copyrightAcknowledgementSubjects);
        if (result.error) {
          setError(result.error);
          setIsLoading(false);
        } else if (result.warning) {
          setIsLoading(false);
          setWarning(result.warning);
        } else if (result.redirect) {
          document.location.href = result.redirect;
        } else {
          // We need to reload the price list when we add picture sets
          updatePriceList();
          update().then(() => {
            history.push(routes.newpictureset.path);
          });
        }
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  const handleOk = () => {
    // We can really just close the dialog when this happens?
    update();
    onClose();
  };

  if (warning) {
    return (
      <WarningLastSubjectNotSelectedDialog
        subject={warning.payload.subject}
        handleOk={handleOk}
      />
    );
  }

  return (
    <Popup onClose={onClose}>
      <PopupHeading>
        <Trans>Add picture code</Trans>
      </PopupHeading>
      <PopupContent>
        <p>
          <PopupTextContent>
            <Trans>
              If you have received a keyword by SMS, email or letter, enter it
              here to access your pictures.
            </Trans>
          </PopupTextContent>
        </p>
        <form onSubmit={addPictureSet}>
          <Box display="flex" justifyContent="center" mt={2}>
            <Box maxWidth={300} display="flex">
              <TextField
                id="dialog-picture-code"
                label={t("Picture code")}
                variant="outlined"
                required={true}
                minLength={4}
                value={code}
                onChange={(e) => setCode(e.target.value)}
                className={classes.codeTextField}
                error={!!error}
                helperText={error}
              />
              <LoadingButton
                isLoading={isLoading}
                disabled={code.length < 6}
                className={classes.button}
                variant="primary"
              >
                <Trans>Add pictures</Trans>
              </LoadingButton>
            </Box>
          </Box>
        </form>
      </PopupContent>
    </Popup>
  );
};

export default AddSubjectDialog;
